import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_79: FaireProductEntity = {
  token: "legacy_prod_abbott-79",
  type: "product",
  name: "Set of 3 Jumbo Straws with Marine Life Caps",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/117d911348d17df10b17a0ce9ae2c61019c514f2b3e1fe74137ca43f9d81d47b.jpeg",
  priceDollars: 8,
  subcategory: "Tableware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_party-supplies"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
